var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Helmet } from "react-helmet";
import { Link, withRouter } from 'react-router-dom';
import { defineMessages, injectIntl } from 'react-intl';
import image1 from "../../assets/img/404.svg";
import image2 from "../../assets/img/404-en.svg";
import { connect } from 'react-redux';
import * as AccountResources from '../../constants/accountResourceNames';
var messages = defineMessages({
    page_not_found: {
        id: 'page.not_found',
        defaultMessage: 'Страница не существует'
    },
    page_not_found__title: {
        id: 'page.not_found__title',
        defaultMessage: 'Страница не найдена'
    },
    page_not_found__sport: {
        id: 'page.not_found__sport',
        defaultMessage: 'Спорт'
    },
    page_not_found__games: {
        id: 'page.not_found__games',
        defaultMessage: 'Игры'
    }
});
var NotFound = /** @class */ (function (_super) {
    __extends(NotFound, _super);
    function NotFound() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotFound.prototype.render = function () {
        var _a = this.props, history = _a.history, client = _a.client, auth = _a.auth;
        history.location.pathname = '/404';
        var isAvailable = auth.user.gamblerId ? auth.user.accountResourceId === AccountResources.US : client.country === "KG";
        var locale = this.props.intl.locale;
        var image = locale === "ru" ? image1 : image2;
        return (_jsxs("div", __assign({ className: 'not-found' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: this.props.intl.formatMessage(messages.page_not_found__title) }) }), _jsx("img", { src: image, alt: this.props.intl.formatMessage(messages.page_not_found) }), _jsx("p", __assign({ className: 'not-found__paragraph' }, { children: this.props.intl.formatMessage(messages.page_not_found) })), _jsx(Link, __assign({ to: '/' }, { children: _jsx("div", __assign({ className: 'not-found__btn_live' }, { children: "Live" })) })), _jsx(Link, __assign({ to: '/sport' }, { children: _jsx("div", __assign({ className: 'not-found__btn_sport' }, { children: this.props.intl.formatMessage(messages.page_not_found__sport) })) })), isAvailable && (_jsx(Link, __assign({ to: '/games' }, { children: _jsx("div", __assign({ className: 'not-found__btn_games' }, { children: this.props.intl.formatMessage(messages.page_not_found__games) })) })))] })));
    };
    return NotFound;
}(React.Component));
;
export default connect(function (state) { return ({
    client: state.application.get("client"),
    auth: state.application.get("auth")
}); })(withRouter(injectIntl(NotFound)));



// WEBPACK FOOTER //
// ./src/containers/app/404.jsx